import { Box, Grid } from '@chakra-ui/react';
import AccountDetails from 'views/admin/profile/components/AccountDetails';
import {useEffect} from "react";
import {useDispatch} from "react-redux";
import {FetchAccountDetails, FetchBalance} from "../../../listener/signin/action";

export default function Overview() {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(FetchAccountDetails());
		dispatch(FetchBalance());
	}, [dispatch])

	return (
		<Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
			<Grid
				mb='20px'
				templateColumns={{
					base: '1fr',
					lg: 'repeat(2, 1fr)',
					'2xl': '1.34fr 1.62fr 1fr'
				}}
				templateRows={{
					base: '1fr',
					lg: 'repeat(2, 1fr)',
					'2xl': '1fr'
				}}
				gap={{ base: '20px', xl: '20px' }}>
				<AccountDetails gridArea={{ base: '2 / 1 / 3 / 2', lg: '1 / 1 / 2 / 3' }} pe='20px' />
			</Grid>
		</Box>
	);
}
